import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ActiveAlarm {
    id: number;
    imei: string;
}

@Injectable({
    providedIn: 'root'
})
export class AlarmStateService {

    private currentAlarmSubject = new BehaviorSubject<ActiveAlarm | null>(null);
    public currentAlarm$ = this.currentAlarmSubject.asObservable();

    /**
     * 352: zakończenie obsługi alarmu przeładowuje stronę, a przeładowanie ubija trwającą
     * rozmowę. Widget telefonu zapisuje ją wtedy przy zamykaniu strony i po tej fladze
     * poznaje, że rozmowa skończyła się razem z alarmem („Zakończone"), a nie została
     * ucięta przez F5 czy zamknięcie karty („Przerwane"). Osobna od `currentAlarm`, bo
     * alarm czyści się przy każdym wyjściu z ekranu, także bez zakończenia obsługi.
     * Żyje tylko w pamięci — przeładowanie kasuje ją samo.
     */
    private alarmFinished = false;

    setCurrentAlarm(id: number, imei: string): void {
        this.currentAlarmSubject.next({ id, imei });
    }

    clearCurrentAlarm(): void {
        this.currentAlarmSubject.next(null);
    }

    getCurrentAlarm(): ActiveAlarm | null {
        return this.currentAlarmSubject.value;
    }

    /** Obsługa alarmu została zakończona — strona zaraz się przeładuje. */
    markAlarmFinished(): void {
        this.alarmFinished = true;
    }

    wasAlarmFinished(): boolean {
        return this.alarmFinished;
    }
}
